import React from 'react'

function MyHotelBookings() {
  return (
    <div>
      my hotek biookings
    </div>
  )
}

export default MyHotelBookings
